// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2227) return "static/css/2227.14ef073132ad062090f1.css";
	if (chunkId === 1488) return "static/css/receiver.d2fa50e600c8902170ab.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1412":"4f767f2564a62b1968c8","1904":"bd1dc93f18705474994a","4102":"bd1dc93f18705474994a","4983":"bd1dc93f18705474994a","6454":"bd1dc93f18705474994a"}[chunkId] + ".chunk.css";
};